module.exports = __webpack_public_path__ + "img/raindrop.30aab739.svg";